export const SessionStorageKeys = {
  // Stores the authenticated user payload for the current tab session.
  user: "user",
  // Keeps the in-progress native language selection across auth flows.
  tempNativeLanguage: "temp_native_lang",
  // Flags that a lesson had video disabled for post-session feedback.
  videoDisabled: "talaera_video_disabled",
  // Marks that the conversation is currently in screen sharing mode.
  shareScreenMode: "Talaera_share_screen_mode",
} as const;

export const LocalStorageKeys = {
  // Temporarily holds a serialized sessionStorage snapshot for new tabs.
  sessionStorageSnapshot: "sessionStorage",
  // Enables verbose client-side console logging when present. Set by hand in
  // devtools; nothing in the app writes it.
  enableConsoleLogging: "enableConsoleLogging",
  // Persists the user's chosen interface language across visits.
  language: "language",
  // Caches Tokbox session bootstrap data between flows.
  tokboxSessionData: "tokbox_session_data",
  // Persists the admin monitoring time query string across reloads.
  adminMonitoringTime: "talaera_admin_monitoringTime",
  // Tracks recently opened students for quick access.
  recentStudents: "Talaera_recent_students",
  // Tracks recently used tags for quick reuse.
  recentTags: "Talaera_recent_tags",
  // Stores recent dictionary searches for suggestions.
  dictionaryPreviousSearch: "Talaera_dictionary_search",
  // Records whether the free-form editor tour has been shown.
  teacherExerciseFreeFormEditorTour: "Talaera_teacher_exerciseFreeFormEditorTour",
  // Records whether the fill-in-the-blanks editor tour has been shown.
  teacherExerciseFillBlanksEditorTour: "Talaera_teacher_exerciseFillBlanksEditorTour",
} as const;
